var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{staticClass:"company-select",attrs:{"disabled":_vm.loading || _vm.options.length == 0,"label-field":"Компания","size":"lg","options":_vm.options},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }